export const environment = {
  production: true,
  api: 'https://#{AppUri}#/api',
  tenant: '#{Azure:TenantId}#',
  clientId: '#{Azure:ClientId}#'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts